'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./Button.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(props) {
    return _react2.default.createElement(
        'button',
        { disabled: props.disabled, className: (0, _classnames2.default)('Button', props.className),
            type: props.type || 'button',
            onClick: props.onClickFn },
        props.children
    );
};

Button.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array, _propTypes2.default.string]).isRequired,
    onClickFn: _propTypes2.default.func,
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    type: _propTypes2.default.string
};

exports.default = Button;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/buttons/Button.js
// module id = 34
// module chunks = 0